import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    Image,
    TouchableHighlight,
    TouchableOpacity,
    View, Text,
} from "react-native";
import {moderateScale} from "../tools/Scaling";
import Colors, {colorPrimary, red} from "../tools/Colors";
import HMTextView from "../customviews/HMTextView";
import i18n from './../I18n/i18n.js';
import {connect} from "react-redux";
import {typeExport} from "../redux/store/type";
import * as NavigationService from "../redux/NavigationService";
import PathFile from "../assets/PathFile";
import HMIcon from "./HMIcon";

class DialogConnectionCustomize extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {style, textt, onPress, onPressCancel, numberOfLines, again, WiFiReview, onPressWiFiReview, img} = this.props;
        return (
            <TouchableHighlight
                onPress={onPressCancel}
                style={[style ? style : {
                    position: 'absolute',
                    flex: 1,
                    // height:'100%',
                    alignContent: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',

                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    zIndex: 9999
                }]}>
                <View style={[style ? {
                    justifyContent: 'center',
                    alignItems: 'center',
                } : {
                    flexDirection: 'column',
                    borderWidth: 1,

                    ...Platform.select({
                        ios: {
                            shadowColor: '#000',
                            shadowOffset: {width: 0, height: 2},
                            shadowOpacity: 0.2,
                        },
                        android: {
                            elevation: 1

                        },
                    }),
                    width: '70%',
                    minHeight: moderateScale(150),
                    margin: 'auto',
                    backgroundColor: 'white',
                    borderRadius: moderateScale(10),
                    justifyContent: 'center',
                    alignItems: 'center',
                }]}>
                    {/*<Icon name="ios-wifi-outline" color={red}  size={30} style={{ marginHorizontal: moderateScale(10) }} />*/}
                    <Image style={{
                        marginHorizontal: moderateScale(10),
                        height: moderateScale(120),
                        width: moderateScale(120),
                        tintColor: !img ? Colors.red : Colors.colorPrimary,
                        marginVertical: moderateScale(15)
                    }}
                          // source={Platform.OS !== "web" ? (img ? img : PathFile.image.no_wifi) : {uri: typeExport._baseUrlImageAssets + "no_wifi.png"}}
                           source={(img ? img : PathFile.image.no_wifi) }
                    />


                    <HMTextView
                        type={"bold"}
                        style={styles.modalText}
                        text={this.props.ConnectionType && this.props.ConnectionType.isConnected ? "ارتباط شما با سرور قطع است" : "لطفا از اتصال دستگاه خود به اینترنت مطمئن شوید"}
                        //text={global.MyVar}
                    >

                    </HMTextView>

                    <HMTextView style={{
                        fontSize: moderateScale(14),
                        marginVertical: moderateScale(16),
                        marginHorizontal: moderateScale(6),
                        textAlign: 'center',
                        color: 'black'
                    }}
                                text={this.props.ConnectionType && this.props.ConnectionType.isConnected ? "چنانچه از فیلتر شکن استفاده می نمائید فیلتر شکن  خود را خاموش کنید.\n" +
                                    "اینترنت ثابت خود را به همراه و یا برعکس تغییر دهید. \n" +
                                    (typeExport._TypeApp === "137" && !(typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") ? `با شماره 137 تماس بگیرید و مشکل را گزارش نمائید.` : ``) : "لطفا از اتصال دستگاه خود به اینترنت مطمئن شوید"}
                        //text={global.MyVar}
                    >

                    </HMTextView>


                    <TouchableOpacity


                        style={{
                            width: moderateScale(140),
                            height: moderateScale(40),
                            backgroundColor: Colors.colorPrimary,
                            borderRadius: moderateScale(6),
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: moderateScale(10)

                        }}
                        onPress={onPress}
                    >
                        <View style={{flexDirection: "row", alignSelf: 'center',}}>
                            <HMTextView
                                text={again ? i18n.t('constant.Back') : i18n.t('constant.retry')}

                                //  text={"تنظیمات وب سرویس"}
                                style={{color: "white", fontSize: moderateScale(14)}}
                            />

                        </View>
                    </TouchableOpacity>


                    {/*  {
                        Platform === "android" && (this.props.ConnectionType && this.props.ConnectionType.type != 'cellular') && (WiFiReview && !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus && this.props.ConnectionInternetHotspot)) ?
                            // WiFiReview && !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus) ?

                            <TouchableOpacity


                                style={styles.buttonModalStyle}
                                onPress={onPressWiFiReview}
                            >
                                <View style={{flexDirection: "row", alignSelf: 'center',}}>
                                    <HMTextView
                                        text={i18n.t('constant.WiFiReview')}
                                        //  text={"تنظیمات وب سرویس"}
                                        style={{color: "white", fontSize: moderateScale(14)}}
                                    />

                                </View>
                            </TouchableOpacity>

                            :
                            null
                    }*/}
                    {
                        Platform === "android" && typeExport.NameApp == "Satia" ?

                            // WiFiReview && !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus) ?

                            <TouchableOpacity


                                style={styles.buttonModalStyle}
                                onPress={onPressWiFiReview}
                            >
                                <View style={{flexDirection: "row", alignSelf: 'center',}}>
                                    <HMIcon name={"wifi"}
                                            type={"FontAwesome"}
                                            style={{
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.gray,
                                                width: moderateScale(29),
                                                height: moderateScale(29),
                                                fontSize: moderateScale(24)
                                            }}/>
                                    <HMTextView
                                        //text={i18n.t('constant.WiFiReview')}
                                        text={"اتصال با هات اسپات"}
                                        style={{color: "white", fontSize: moderateScale(14)}}
                                    />

                                </View>
                            </TouchableOpacity>

                            :
                            null
                    }
                    {
                        typeExport._TypeApp == "125" ?
                            <TouchableOpacity
                                style={{
                                    width: "82%",


                                    marginTop: moderateScale(4),

                                }}
                                onPress={() => {

                                    NavigationService.navigateParams("WebServiceScreen", {menu: false})
                                }
                                }
                            >
                                <View style={{flexDirection: "row", alignSelf: 'center',}}>

                                    <HMTextView
                                        text={i18n.t('constant.WeberviceSettings')}
                                        //  text={"تنظیمات وب سرویس"}
                                        style={{
                                            color: Colors.blue,
                                            fontSize: moderateScale(13),
                                        }}/>

                                </View>
                            </TouchableOpacity>
                            : null
                    }

                </View>

            </TouchableHighlight>
        );
    }

    getText() {
        if (this.props.ConnectionType) {
            return "ارتباط شما با سرور قطع است"
        }
        else {
            return "لطفا از اتصال دستگاه خود به اینترنت مطمئن شوید"
        }
    }
}

const mapStateToProps = state => {
    return {
        DataSplashScreen: state.reducerSplashSatiaScreen,
        wifiIsEnabled: state.reducerSplashSatiaScreen?.wifiIsEnabled,
        wifiConnectionStatus: state.reducerSplashSatiaScreen?.wifiConnectionStatus,
        ConnectionType: state.reducerSplashSatiaScreen?.ConnectionType,
        ConnectionInternetHotspot: state.reducerSplashSatiaScreen?.ConnectionInternetHotspot,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  setIsConnected: (data) => dispatch(serviceActionSetIsConnected(data)),
        // callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(DialogConnectionCustomize);
const styles = StyleSheet.create({
    modalBackDrop: {
        position: 'relative',
        flex: 1,
        // height:'100%',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 9999
    },
    modalDialog: {
        flexDirection: 'column',
        borderWidth: 1,

        ...Platform.select({
            ios: {
                shadowColor: '#000',
                shadowOffset: {width: 0, height: 2},
                shadowOpacity: 0.2,
            },
            android: {
                elevation: 1

            },
        }),
        width: '70%',
        minHeight: 150,
        margin: 'auto',
        backgroundColor: 'white',
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalLoading: {
        textAlign: "center",
    },
    modalText: {
        fontSize: moderateScale(18),
        marginVertical: moderateScale(6),
        marginHorizontal: moderateScale(6),
        textAlign: 'center',
        color: 'black'
    },
    modalButton: {

        borderRadius: moderateScale(2),
        color: Colors.green
    },
    buttonModalStyle: {
        width: '50%',
        backgroundColor: Colors.colorPrimary,
        // height:moderateScale(40),
        padding: 10,
        margin: 10,
    }
});

/*

      alignItems: 'flex-start',
      alignItems: 'flex-end',

*/
